import { useEffect, useState } from "react";

// Debounces a fast-changing value (e.g. search input) so consumers only
// react once the value has settled for `delay` ms.
const useDebouncedValue = (value, delay = 400) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
};

export default useDebouncedValue;
